import { render, staticRenderFns } from "./AscentGymRouteSmallCard.vue?vue&type=template&id=b078546c"
import script from "./AscentGymRouteSmallCard.vue?vue&type=script&lang=js"
export * from "./AscentGymRouteSmallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports